

















import Vue from 'vue';

const baseUrl = 'https://remolabo.net/service/';

export default Vue.extend({
  name: 'CommonFooter',
  props: {
    mode: String,
  },
  data() {
    return {
      links: [
        [
          { name: baseUrl + 'contact/#form', text: 'お問い合わせ' },
          { name: baseUrl + 'terms-of-use', text: '利用規約' },
        ],
        [
          { name: baseUrl + 'privacy-policy', text: 'プライバシーポリシー' },
          { name: baseUrl + 'terms-of-sale', text: '特定商取引法表記' },
        ],
      ],
    };
  },
});
